export default __webpack_public_path__ + "static/media/Audio_Icon.3f8d96af.svg";